/**
 * EventsTab Constants
 */

import type { SoftphoneEvent } from 'Modules/softphone/services/EventService';

/** Filter token for events that belong to no call — registration, devices. */
export const UNATTRIBUTED = '__unattributed__';

/**
 * How each channel is labelled on its filter chip.
 *
 * Shared, so the sentence that reports a filter matched nothing names it with
 * the same word the chip does — "Device", not "DEVICE".
 */
export const CHANNEL_LABELS: Record<SoftphoneEvent['type'], string> = {
  SIP: 'SIP',
  RTP: 'RTP',
  DEVICE: 'Device',
  CALL: 'Call',
};
